<template>
  <el-select v-model="modelValue" :multiple="multiple" transfer :disabled="disabled" clearable>
    <el-option
      v-for="(item, index) in list"
      :value="item[selectParams.select_id]"
      :label="item[selectParams.select_name]"
      :key="index"
      :disabled="optionDisabled && optionDisabled(item)"
    ></el-option>
  </el-select>
</template>
<script>
export default {
  name: 'FormSelect',
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
    },
    value: {},
    idKey: {
      type: String,
      default: 'id',
    },
    nameKey: {
      type: String,
      default: 'name',
    },
    url: {
      type: String,
    },
    params: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasPage: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
    },
    optionDisabled: {
      type: Function,
    },
  },
  model: {
    prop: 'value',
    event: 'modelValueChange',
  },
  computed: {
    selectParams() {
      return {
        select_name: this.nameKey,
        select_id: this.idKey,
        url: this.url,
      };
    },
  },
  data() {
    return {
      list: [],
      modelValue: this.multiple ? [] : '',
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (this.multiple && typeof val === 'string') {
          const tmp = val ? val.split(',') : [];
          this.modelValue = tmp.map((i) => +i);
        } else {
          this.modelValue = val;
        }
      },
    },
    modelValue(newValue) {
      this.$emit('modelValueChange', Array.isArray(newValue) ? newValue.join() : newValue);
      if (newValue) {
        this.$emit(
          'change',
          this.list.find((t) => t[this.selectParams.select_id] == newValue),
        );
      } else {
        this.$emit('change');
      }
    },
    params() {
      this.getData();
    },
    items(newValue) {
      this.list = newValue;
    },
  },
  async created() {
    this.modelValue = this.value;
    if (this.selectParams && this.selectParams.url) {
      await this.getData();
    } else if (this.items) {
      this.list = this.items;
    }
  },
  methods: {
    async getData() {
      let params = { ...this.params };
      if (this.hasPage) {
        params.limit = 999999;
      }
      let data = await this.$http.get(this.selectParams.url, params);
      this.list = data.list || data;
      this.$emit('onGetList', this.list);
    },
  },
};
</script>
